import script from "./BoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardView.vue?vue&type=script&setup=true&lang=js"

import "./BoardView.vue?vue&type=style&index=0&id=1113da1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1113da1d"]])

export default __exports__